module.exports = __webpack_public_path__ + "static/media/foot-left.81285047.svg";